// extracted by mini-css-extract-plugin
export default {"container":"RJ-z","topReviewHeading":"SJ-z","criticalReview":"TJ-z","favorableReview":"UJ-z","vsSeparator":"VJ-z"};